module.exports = __webpack_public_path__ + "static/media/prepaid-empty-repeat.8a30a6f8.svg";